import React from 'react';
import ArticleField from '../ArticleField';
import { Switch } from '@material-ui/core';

interface OpinionProps {
    value: boolean,
    onChange: (value: boolean) => void
}

const Opinion = (props: OpinionProps) => (
    <ArticleField label="Opinion">
        <Switch checked={props.value} onChange={(e) => {
            props.onChange(e.target.checked);
        }} />
    </ArticleField>
);

export default Opinion;